import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = [
    "onClick"
];
const _hoisted_2 = {
    class: "file-name"
};
const _hoisted_3 = {
    class: "delete-icon"
};
const _hoisted_4 = [
    "onClick"
];
const _hoisted_5 = {
    class: "upload-loading"
};
const _hoisted_6 = {
    class: "progress-text"
};
const _hoisted_7 = {
    class: "upload-loading"
};
const _hoisted_8 = {
    class: "progress-text"
};
const _hoisted_9 = {
    class: "file-name"
};
const _hoisted_10 = {
    class: "delete-icon"
};
import config from "@/config/upload";
import Sortable from "sortablejs";
import { ref, nextTick, watch, computed, onMounted, onBeforeUnmount } from "vue";
import { useFormItem } from "element-plus";
import { debugWarn } from "element-plus/es/utils/error";

import { ElMessage, ElNotification } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/notification/style/css';
export default {
    __name: 'index',
    props: {
        modelValue: {
            type: [
                String,
                Array
            ],
            default: ""
        },
        max: {
            type: [
                String,
                Number
            ],
            default: 10
        },
        size: {
            type: [
                String,
                Number
            ],
            default: 60
        },
        width: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        height: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        multiple: {
            type: Boolean,
            default: false
        },
        draggable: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        accept: {
            type: String,
            default: "image/gif, image/jpeg, image/png"
        },
        apiObj: {
            type: Object,
            default: ()=>{}
        },
        name: {
            type: String,
            default: config.filename
        },
        data: {
            type: Object,
            default: ()=>{}
        },
        maxSize: {
            type: Number,
            default: config.maxSizeFile
        },
        limit: {
            type: Number,
            default: 0
        },
        onSuccess: {
            type: Function,
            default: ()=>{
                return true;
            }
        }
    },
    emits: [
        "update:modelValue",
        "success",
        "closed"
    ],
    setup (__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const customStyle = computed(()=>{
            return {
                width: `${props.width || props.size}px`,
                height: `${props.height || props.size}px`
            };
        });
        const fileData = computed({
            get: ()=>props.modelValue,
            set: (val)=>emit('update:modelValue', val)
        });
        const { formItem } = useFormItem();
        watch(()=>props.modelValue, (newVal)=>{
            formItem?.validate('change').catch((err)=>debugWarn(err));
        });
        const fileList = ref([]);
        const uploading = ref(false);
        const uploadProgress = ref(0);
        // 拖拽排序
        const imageContentRef = ref(null);
        const listVersion = ref(0);
        let sortableInstance = null;
        onMounted(()=>{
            if (props.multiple && props.draggable && !props.disabled) {
                nextTick(()=>{
                    if (!imageContentRef.value) return;
                    sortableInstance = Sortable.create(imageContentRef.value, {
                        draggable: ".sort-item",
                        animation: 200,
                        onEnd ({ newIndex, oldIndex }) {
                            if (newIndex === oldIndex || newIndex == null || oldIndex == null) return;
                            const list = [
                                ...Array.isArray(fileData.value) ? fileData.value : []
                            ];
                            const curr = list.splice(oldIndex, 1)[0];
                            list.splice(newIndex, 0, curr);
                            fileData.value = list;
                            // Sortable 会直接移动 DOM 节点，与 Vue 渲染产生冲突，
                            // 更新版本号强制按数据顺序重建列表
                            listVersion.value++;
                        }
                    });
                });
            }
        });
        onBeforeUnmount(()=>{
            sortableInstance?.destroy();
            sortableInstance = null;
        });
        const before = (file)=>{
            const maxSize = file.size / 1024 / 1024 < props.maxSize;
            if (!maxSize) {
                ElMessage.warning(`上传文件大小不能超过 ${props.maxSize}MB!`);
                return false;
            }
            // 开始上传，显示加载状态
            uploading.value = true;
            uploadProgress.value = 0;
        };
        const success = (res, file)=>{
            // 上传完成，隐藏加载状态
            uploading.value = false;
            uploadProgress.value = 0;
            let os = props.onSuccess(res, file);
            if (os != undefined && os == false) {
                return false;
            }
            let response = config.parseData(res);
            if (props.multiple) {
                if (fileData.value.length < props.max) {
                    fileData.value.push(response.src);
                }
            } else {
                fileData.value = response.src;
            }
        };
        const error = (err)=>{
            // 上传失败，隐藏加载状态
            uploading.value = false;
            uploadProgress.value = 0;
            ElNotification.error({
                title: "上传文件未成功",
                message: err
            });
        };
        const request = (param)=>{
            var apiObj = config.apiObjFile;
            if (props.apiObj) {
                apiObj = props.apiObj;
            }
            const data = new FormData();
            data.append(param.filename, param.file);
            for(const key in param.data){
                data.append(key, param.data[key]);
            }
            apiObj.post(data, {
                onUploadProgress: (e)=>{
                    const complete = parseInt(e.loaded / e.total * 100 | 0, 10);
                    // 更新上传进度
                    uploadProgress.value = complete;
                    param.onProgress({
                        percent: complete
                    });
                }
            }).then((res)=>{
                var response = config.parseData(res);
                if (response.code == config.successCode) {
                    param.onSuccess(res);
                } else {
                    param.onError(response.msg || "未知错误");
                }
            }).catch((err)=>{
                param.onError(err);
            });
        };
        const handleExceed = ()=>{
            ElMessage.warning(`当前设置最多上传 ${props.limit} 个文件，请移除后上传!`);
        };
        const handlerRemove = (index, isMultiple = false)=>{
            if (isMultiple) {
                (Array.isArray(fileData.value) ? fileData.value : []).splice(index, 1);
                fileData.value = [
                    ...fileData.value
                ];
            } else {
                fileData.value = "";
            }
        };
        // 判断是否为图片文件
        const isImageFile = (url)=>{
            if (!url) return false;
            const imageExtensions = [
                '.jpg',
                '.jpeg',
                '.png',
                '.gif',
                '.bmp',
                '.webp',
                '.svg'
            ];
            const lowerUrl = url.toLowerCase();
            return imageExtensions.some((ext)=>lowerUrl.includes(ext));
        };
        // 获取文件名
        const getFileName = (url)=>{
            if (!url) return '';
            const parts = url.split('/');
            return parts[parts.length - 1] || '未知文件';
        };
        // 处理文件点击（在新窗口打开）
        const handleFileClick = (url)=>{
            if (url) {
                window.open(url, '_blank');
            }
        };
        return (_ctx, _cache)=>{
            const _component_el_image = _resolveComponent("el-image");
            const _component_el_icon_document = _resolveComponent("el-icon-document");
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_icon_delete = _resolveComponent("el-icon-delete");
            const _component_el_icon_loading = _resolveComponent("el-icon-loading");
            const _component_el_progress = _resolveComponent("el-progress");
            const _component_ElIconPlus = _resolveComponent("ElIconPlus");
            const _component_el_upload = _resolveComponent("el-upload");
            return _openBlock(), _createElementBlock("div", {
                class: "image-content",
                ref_key: "imageContentRef",
                ref: imageContentRef
            }, [
                __props.multiple ? (_openBlock(), _createElementBlock(_Fragment, {
                    key: 0
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileData.value, (item, index)=>{
                        return _openBlock(), _createElementBlock("div", {
                            class: _normalizeClass([
                                "imageBtn",
                                {
                                    'sort-item': __props.draggable,
                                    'is-draggable': __props.draggable
                                }
                            ]),
                            style: _normalizeStyle(customStyle.value),
                            key: `${listVersion.value}-${item}`
                        }, [
                            isImageFile(item) ? (_openBlock(), _createBlock(_component_el_image, {
                                key: 0,
                                style: {
                                    "width": "100%",
                                    "height": "100%"
                                },
                                "initial-index": index,
                                "preview-src-list": fileData.value,
                                src: item,
                                fit: "cover",
                                "preview-teleported": ""
                            }, null, 8, [
                                "initial-index",
                                "preview-src-list",
                                "src"
                            ])) : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "file-display",
                                onClick: ($event)=>handleFileClick(item)
                            }, [
                                _createVNode(_component_el_icon, {
                                    class: "file-icon"
                                }, {
                                    default: _withCtx(()=>[
                                            _createVNode(_component_el_icon_document)
                                        ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_tooltip, {
                                    content: getFileName(item),
                                    placement: "top"
                                }, {
                                    default: _withCtx(()=>[
                                            _createElementVNode("div", _hoisted_2, _toDisplayString(getFileName(item)), 1)
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "content"
                                ]),
                                _cache[4] || (_cache[4] = _createElementVNode("div", {
                                    class: "file-success"
                                }, "上传成功", -1))
                            ], 8, _hoisted_1)),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("span", {
                                    class: "del",
                                    onClick: _withModifiers(($event)=>handlerRemove(index, true), [
                                        "stop"
                                    ])
                                }, [
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(()=>[
                                                _createVNode(_component_el_icon_delete)
                                            ]),
                                        _: 1
                                    })
                                ], 8, _hoisted_4)
                            ])
                        ], 6);
                    }), 128)),
                    fileData.value.length < __props.max ? (_openBlock(), _createElementBlock(_Fragment, {
                        key: 0
                    }, [
                        uploading.value ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "imageBtn uploading-box",
                            style: _normalizeStyle(customStyle.value)
                        }, [
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_el_icon, {
                                    class: "is-loading"
                                }, {
                                    default: _withCtx(()=>[
                                            _createVNode(_component_el_icon_loading)
                                        ]),
                                    _: 1
                                }),
                                _cache[5] || (_cache[5] = _createElementVNode("div", {
                                    class: "loading-text"
                                }, "上传中", -1)),
                                _createElementVNode("div", _hoisted_6, _toDisplayString(uploadProgress.value) + "%", 1),
                                _createVNode(_component_el_progress, {
                                    percentage: uploadProgress.value,
                                    "show-text": false
                                }, null, 8, [
                                    "percentage"
                                ])
                            ])
                        ], 4)) : (_openBlock(), _createBlock(_component_el_upload, {
                            key: 1,
                            "file-list": fileList.value,
                            "onUpdate:fileList": _cache[0] || (_cache[0] = ($event)=>fileList.value = $event),
                            accept: __props.accept,
                            multiple: "",
                            style: _normalizeStyle(customStyle.value),
                            name: __props.name,
                            drag: "",
                            showFileList: false,
                            "http-request": request,
                            data: __props.data,
                            action: "",
                            "before-upload": before,
                            "on-success": success,
                            "on-error": error,
                            "on-exceed": handleExceed
                        }, {
                            default: _withCtx(()=>[
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(()=>[
                                                _createVNode(_component_ElIconPlus)
                                            ]),
                                        _: 1
                                    })
                                ]),
                            _: 1
                        }, 8, [
                            "file-list",
                            "accept",
                            "style",
                            "name",
                            "data"
                        ]))
                    ], 64)) : _createCommentVNode("", true)
                ], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                    key: 1
                }, [
                    uploading.value ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "imageBtn uploading-box",
                        style: _normalizeStyle(Object.assign({
                            margin: 0
                        }, customStyle.value))
                    }, [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_el_icon, {
                                class: "is-loading"
                            }, {
                                default: _withCtx(()=>[
                                        _createVNode(_component_el_icon_loading)
                                    ]),
                                _: 1
                            }),
                            _cache[6] || (_cache[6] = _createElementVNode("div", {
                                class: "loading-text"
                            }, "上传中", -1)),
                            _createElementVNode("div", _hoisted_8, _toDisplayString(uploadProgress.value) + "%", 1),
                            _createVNode(_component_el_progress, {
                                percentage: uploadProgress.value,
                                "show-text": false
                            }, null, 8, [
                                "percentage"
                            ])
                        ])
                    ], 4)) : fileData.value ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "imageBtn",
                        style: _normalizeStyle(Object.assign({
                            margin: 0
                        }, customStyle.value))
                    }, [
                        isImageFile(fileData.value) ? (_openBlock(), _createBlock(_component_el_image, {
                            key: 0,
                            style: {
                                "width": "100%",
                                "height": "100%"
                            },
                            src: fileData.value,
                            "preview-src-list": [
                                fileData.value
                            ],
                            fit: "cover",
                            "preview-teleported": ""
                        }, null, 8, [
                            "src",
                            "preview-src-list"
                        ])) : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "file-display",
                            onClick: _cache[1] || (_cache[1] = ($event)=>handleFileClick(fileData.value))
                        }, [
                            _createVNode(_component_el_icon, {
                                class: "file-icon"
                            }, {
                                default: _withCtx(()=>[
                                        _createVNode(_component_el_icon_document)
                                    ]),
                                _: 1
                            }),
                            _createVNode(_component_el_tooltip, {
                                content: getFileName(fileData.value),
                                placement: "top"
                            }, {
                                default: _withCtx(()=>[
                                        _createElementVNode("div", _hoisted_9, _toDisplayString(getFileName(fileData.value)), 1)
                                    ]),
                                _: 1
                            }, 8, [
                                "content"
                            ]),
                            _cache[7] || (_cache[7] = _createElementVNode("div", {
                                class: "file-success"
                            }, "上传成功", -1))
                        ])),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", {
                                class: "del",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event)=>handlerRemove('', false), [
                                    "stop"
                                ]))
                            }, [
                                _createVNode(_component_el_icon, null, {
                                    default: _withCtx(()=>[
                                            _createVNode(_component_el_icon_delete)
                                        ]),
                                    _: 1
                                })
                            ])
                        ])
                    ], 4)) : (_openBlock(), _createBlock(_component_el_upload, {
                        key: 2,
                        "file-list": fileList.value,
                        "onUpdate:fileList": _cache[3] || (_cache[3] = ($event)=>fileList.value = $event),
                        accept: __props.accept,
                        style: _normalizeStyle(customStyle.value),
                        name: __props.name,
                        drag: "",
                        showFileList: false,
                        "http-request": request,
                        data: __props.data,
                        action: "",
                        "before-upload": before,
                        "on-success": success,
                        "on-error": error,
                        "on-exceed": handleExceed
                    }, {
                        default: _withCtx(()=>[
                                _createVNode(_component_el_icon, null, {
                                    default: _withCtx(()=>[
                                            _createVNode(_component_ElIconPlus)
                                        ]),
                                    _: 1
                                })
                            ]),
                        _: 1
                    }, 8, [
                        "file-list",
                        "accept",
                        "style",
                        "name",
                        "data"
                    ]))
                ], 64))
            ], 512);
        };
    }
};
